<div
  class="insurer-card"
  [ngClass]="first ? 'highlight' : ''"
>
<ng-container [ngSwitch]="isVehicleTypeAccess">
  <ng-container *ngSwitchDefault>
    <div *ngIf="requestData.dealerType !== 'POLICYSTREET' && requestData.dealerType !== 'CARSOMEDR'">
      <img
        *ngIf="first && translate.currentLang === 'en'"
        class="cheapest-tag"
        src="https://storage.googleapis.com/ps-asset/affiliate/logo/Tag.png"
        alt=""
      />
      <img
        *ngIf="first && translate.currentLang !== 'en'"
        class="cheapest-tag"
        src="https://storage.googleapis.com/ps-asset/affiliate/logo/Tag-bm.png"
        alt=""
      />
    </div>
    <div *ngIf="requestData.dealerType == 'POLICYSTREET' || requestData.dealerType == 'CARSOMEDR'">
      <img
					*ngIf="showTag"
					[src]="getRibbonType(item?.code)"
					class="grab-ribbon"
				/>
    </div>
    
  </ng-container>
  <ng-container *ngSwitchCase="'Motorcycle'">
    <img
      *ngIf="item.requestType == 'MotorcycleTPRequest'"
      class="insurance-type-tag"
      [src]="'https://storage.googleapis.com/ps-asset/motorcycle/shared/TP-tag-'+translate.currentLang+'.png'"
    />
    <img
      *ngIf="item.requestType !== 'MotorcycleTPRequest'"
      class="insurance-type-tag"
      [src]="'https://storage.googleapis.com/ps-asset/motorcycle/shared/COM-tag-'+translate.currentLang+'.png'"
    />
  </ng-container>
</ng-container>


<div class="insurer-card__header" [ngClass]="first ? 'highlight' : ''">
  <div class="insurer-card__header__logo">
    <img [src]="item?.image" />
  </div>

  <div class="insurer-card__header__pricing">
    <!-- Total Price -->
    <div class="pricing-total">
      <span>RM</span>
      <span class="price-value">{{ totalPrice | number : "1.2-2" }}</span>
    </div>

    <!-- Sum Insured Section -->
    <div class="sum-insured-with-badge">
      <!-- Badge if present -->
      <span
        *ngIf="item?.sumInsuredRange === 'Highest'"
        class="sum-insured__badge_Highest"
      >
        {{ "common.Highest" | translate }}
      </span>
      <span
        *ngIf="item?.sumInsuredRange === 'Lowest'"
        class="sum-insured__badge_Lowest"
      >
        {{ "common.Lowest" | translate }}
      </span>

      <!-- Sum Insured Text -->
      <div class="sum-insured">
        <p>
          {{ "common.sumInsured" | translate }} ({{"common." + item?.typeOfSum | translate}}):
        </p>
        <p>RM {{ item.sumInsured | number : "1.2-2" }}</p>
      </div>
    </div>
  </div>
</div>

  <div class="insurer-card__content">
    <div class="insurer-card__content__benefit">
      <div class="insurer-card__content__benefit__flex">
        <div class="insurer-card__content__benefit__title">{{ "common.benefits" | translate | titlecase }}</div>
        <div class="insurer-card__content__benefit__note">{{ "insurerDetails.subjectToPolicy" | translate }}</div>
      </div>

      <ul>
        <ng-container *ngFor="let benefit of benefits">
          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'driver'
            "
          >
            <img src="assets/image/protection-drivers.svg" />
            <span>
              {{ "comparison.protectionDriver" | translate }}:
              <b class="color-dark-green">
                {{benefit.description | translate}}
              </b>
            </span>
          </li>

         <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type === 'allRiders'
            "
          >
            <img
              style="min-width: 24px !important"
              src="assets/image/two-wheeler.png"
            />
           <span>
              {{ "insurerDetails.allRiders" | translate }}
              <b class="color-dark-green">
                {{benefit.description | translate}}
              </b>
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'towing'
            "
          >
            <img src="assets/image/towing-service.svg" />
            <span>
              {{ "insurerDetails.towingService" | translate }}
              <b class="color-dark-green">
                {{benefit.description | translate}}
              </b>
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == '24hrTowing'
            "
          >
            <img src="assets/image/towing-service.svg" />
            <span>
              {{ "insurerDetails.24hrTowingService" | translate }}
              <b class="color-dark-green">
                {{benefit.description | translate}}
              </b>
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'unlimitedTowing'
            "
          >
            <img src="assets/image/towing-service.svg" />
            <span>
              {{ "insurerDetails.unlimitedTowingService" | translate }}
            </span>
          </li>

          <li *ngIf="hasTranslation(benefit.description) && benefit.type == 'free'" class="benefit-item">
            <div class="benefit-row">
              <mat-icon class="benefit-icon color-dark-green">check_circle</mat-icon>
              <span class="benefit-text">
                <b class="color-dark-green">{{ "benefits.free" | translate }}</b>
                {{ benefit.description | translate }}
              </span>
            </div>
          </li>

         <li *ngIf="hasTranslation(benefit.description) && benefit.type == ''" class="benefit-item">
          <div class="benefit-row">
            <div class="yellow-circle">
              <mat-icon>thumb_up</mat-icon>
            </div>
            <span class="benefit-text">{{ benefit.description | translate }}</span>
          </div>
        </li>

          <li *ngIf="hasTranslation(benefit.description) && benefit.type == 'sectionTitle'">
            <span>{{ benefit.description | translate }}</span>
          </li>
        </ng-container>
      </ul>

      <button
        class="insurer-card__content__benefit__link mb-sm"
        (click)="toggleMoreBenefits()"
        *ngIf="totalBenefits > 4"
      >
        {{
          showMoreBenefits
            ? ("common.seeLess" | translate)
            : ("common.seeAll" | translate) +
              " " +
              totalBenefits +
              " " +
              ("common.benefits" | translate)
        }}
        ...
      </button>
    </div>
    <mat-divider></mat-divider>

    <div class="insurer-card__content__footer">
      <!-- <div
        class="insurer-installment"
        *ngIf="requestData.isOnlinePayment"
      >
        {{ "common.pay" | translate }}
        <b>RM{{ item.total / 3 | number : "1.2-2" }}</b>
        {{ "common.everyMonth" | translate }} <br />{{
          "common.duration" | translate
        }}!
      </div> -->
      <button mat-flat-button class="insurer-card__content__footer__btn" (click)="handleBuyNow()">
        {{ "comparison.buyNow" | translate }}
      </button>
      <div class="">
        <div
          class="instalment-note"
          *ngIf="eppEligibility && eppEligibility.isEligible"
        >
          {{ "common.pay" | translate }}
          <b
            >RM{{
              totalBasePremiumAfterRebate / eppEligibility.months
                | number : "1.2-2"
            }}</b
          >
          <span> {{ "common.everyMonth" | translate }}</span>
          <span>
            {{
              eppEligibility.months == 6
                ? ("common.duration6" | translate)
                : ("common.duration12" | translate)
            }}
            <br
          /></span>
          <span class="instalment-note--sm">
            {{ "common.epp" | translate }}
          </span>
        </div>
        <div class="rebate-note" *ngIf="item?.rebate">
          <img src="assets/image/rebate-crown-icon.png" />
          {{ "common.includedRebate" | translate }}
          <b>RM{{ item?.rebate | number : "1.2-2" }}</b>
        </div>
      </div>

      <ng-container *ngIf="documents?.length">
        <mat-divider></mat-divider>
        <div class="insurer-card__content__footer__documents">
          <ng-container
            *ngFor="let doc of documents; let i = index; let last = last"
          >
            <a class="insurer-card__content__footer__link" [href]="doc.url" target="_blank">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ doc.name }}</span>
            </a>
            <span *ngIf="!last" class="document-divider">|</span>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>